import messages from './Message';
import i18n from '../../i18n';

export function format(err) {
  const code = err.code;
  if (typeof err === 'string') return i18n.t(err, { ns: 'login' });
  let key;
  try {
    if (code === 'request') {
      key = 'requestError';
    } else if (code === 'loading') {
      return null;
    } else {
      key = err?.data?.message;
    }
  } catch (ex) {
    console.error(ex);
    // eslint-disable-next-line no-console
    console.error(err);
  }

  return i18n.t(key, { ns: 'login' });
}
